import { Endpoint } from '@/types/api.type.ts';

export const deliveryPriceEndpoints: Endpoint[] = [
    {
        name: 'getDeliveryPrices',
        method: 'get',
        path: '/delivery-prices/',
    },
    {
        name: 'createDeliveryPrice',
        method: 'post',
        path: '/delivery-prices/',
    },
    {
        name: 'updateDeliveryPrice',
        method: 'patch',
        path: '/delivery-prices/:id',
    },
    {
        name: 'activateDeliveryPrice',
        method: 'patch',
        path: '/delivery-prices/activate-delivery-price/:id',
    },
    {
        name: 'deactivateDeliveryPrice',
        method: 'patch',
        path: '/delivery-prices/deactivate-delivery-price/:id',
    },
    {
        name: 'getDeliveryPrice',
        method: 'get',
        path: '/delivery-prices/:id',
    },
];
